export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/crypto.worker.bc3da3bed7a2bf5a766a.worker.js");
}
